"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDAOFactory__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "daoAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "accessControl",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "creator",
                type: "address",
            },
        ],
        name: "DAOCreated",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "daoImplementation",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "accessControlImplementation",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "salt",
                        type: "bytes32",
                    },
                    {
                        internalType: "string",
                        name: "daoName",
                        type: "string",
                    },
                    {
                        internalType: "string[]",
                        name: "roles",
                        type: "string[]",
                    },
                    {
                        internalType: "string[]",
                        name: "rolesAdmins",
                        type: "string[]",
                    },
                    {
                        internalType: "address[][]",
                        name: "members",
                        type: "address[][]",
                    },
                    {
                        internalType: "string[]",
                        name: "daoFunctionDescs",
                        type: "string[]",
                    },
                    {
                        internalType: "string[][]",
                        name: "daoActionRoles",
                        type: "string[][]",
                    },
                ],
                internalType: "struct IDAOFactory.CreateDAOParams",
                name: "createDAOParams",
                type: "tuple",
            },
        ],
        name: "createDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IDAOFactory__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.IDAOFactory__factory = IDAOFactory__factory;
IDAOFactory__factory.abi = _abi;
